import React from 'react';
import { AliveScope } from 'react-activation';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from 'shared/components/errorBoundary/errorBoundary';
import WithErrorHandler from 'shared/components/errorBoundary/withErrorHandler';
import { currentLanguage } from 'shared/constants/common';
import GrowthBookWrapper from 'shared/hoc/GrowthBookWrapper';
import 'shared/util/localization';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { setupSentry } from './setupSentry';
import { resolveRandomUUID } from './shared/util/utility';
import store from './store';

resolveRandomUUID();

setupSentry();

ReactDOM.render(
	<React.StrictMode>
		<GrowthBookWrapper>
			<Provider store={store}>
				{/* {isSupportedLanguage ? */}
				<BrowserRouter basename={`${currentLanguage === 'pl' ? '' : currentLanguage}`}>
					<WithErrorHandler />
					<ErrorBoundary>
						{/* <ClearCacheComponent> */}
						<HelmetProvider>
							<AliveScope>
								<App />
							</AliveScope>
						</HelmetProvider>
						{/* </ClearCacheComponent> */}
					</ErrorBoundary>
				</BrowserRouter>
				{/* :
				<></>
			} */}
			</Provider>
		</GrowthBookWrapper>
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
